import { Link } from 'react-router-dom';
import styles from './Button.module.css';

const cx = (...parts) => parts.filter(Boolean).join(' ');

/**
 * The prototype's button styles collapsed into variants.
 * Renders as <Link> when `to` is passed, otherwise <button>.
 */
export function Button({
  variant = 'primary',
  size = 'md',
  block = false,
  to,
  className,
  children,
  ...rest
}) {
  const classes = cx(styles.btn, styles[variant], styles[size], block && styles.block, className);

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
}
